import { render, staticRenderFns } from "./ModalLoginSocial.vue?vue&type=template&id=8c6067ae&scoped=true"
import script from "./ModalLoginSocial.vue?vue&type=script&lang=js"
export * from "./ModalLoginSocial.vue?vue&type=script&lang=js"
import style0 from "./ModalLoginSocial.vue?vue&type=style&index=0&id=8c6067ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6067ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c6067ae')) {
      api.createRecord('8c6067ae', component.options)
    } else {
      api.reload('8c6067ae', component.options)
    }
    module.hot.accept("./ModalLoginSocial.vue?vue&type=template&id=8c6067ae&scoped=true", function () {
      api.rerender('8c6067ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modals/ModalLoginSocial.vue"
export default component.exports